<template>
  <!-- Cautions Label and Cautions Details -->
  <div class="row">
    <div class="col-12 py-2 background-cautions">
      <p class="text-center mb-0 font-weight-bold headline" style="font-size: 0.8rem !important;">注意事項</p>
    </div>

    <div class="col-10 mx-auto mt-3">
      <p class="text-justify text" style="word-wrap:break-word">
        <span style="word-wrap:break-word" v-html="cautions"></span>
        <!--{{ cautions }}-->
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "cautions",
  props: {
    cautions: String,
  },
};
</script>

<style scoped></style>
